(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-avelere-pdp-v3"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pdp-v3-section]').forEach((section) => {
    if (section.dataset.pdpV3Initialized === 'true') return;
    section.dataset.pdpV3Initialized = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    let listenerCount = 0;
    const on = (target, type, handler, options = {}) => {
      if (!target) return;
      target.addEventListener(type, handler, { ...options, signal });
      listenerCount += 1;
    };
    on(document, 'shopify:section:unload', (event) => {
      if (event.target === section || event.target?.contains?.(section)) {
        controller.abort();
        section.dataset.pdpV3Initialized = 'false';
      }
    });

    const mainImage = section.querySelector('[data-pdp-v3-main-image]');
    const zoomOpen = section.querySelector('[data-pdp-v3-zoom-open]');
    const zoomDialog = section.querySelector('[data-pdp-v3-lightbox]');
    const zoomImage = section.querySelector('[data-pdp-v3-zoom-image]');
    const zoomCaption = section.querySelector('[data-pdp-v3-zoom-caption]');
    const zoomCounter = section.querySelector('[data-pdp-v3-zoom-counter]');
    const zoomClose = section.querySelector('.pdp-v3__lightbox-close');
    const thumbButtons = Array.from(section.querySelectorAll('[data-pdp-v3-thumb]'));
    const galleryItems = thumbButtons.map((button, index) => ({
      button,
      index,
      largeSrc: button.getAttribute('data-large-src'),
      zoomSrc: button.getAttribute('data-zoom-src') || button.getAttribute('data-large-src'),
    }));
    let activeThumbIndex = Math.max(0, galleryItems.findIndex((item) => item.button.getAttribute('aria-current') === 'true'));
    let lastZoomTrigger = null;

    const syncZoomImage = (index) => {
      const item = galleryItems[index];
      if (!item || !zoomImage) return;
      zoomImage.setAttribute('src', item.zoomSrc || item.largeSrc || '');
      if (zoomCaption) zoomCaption.textContent = `Image ${index + 1}`;
      if (zoomCounter) zoomCounter.textContent = `${index + 1} / ${galleryItems.length}`;
    };

    const selectThumb = (button, index) => {
      const largeSrc = button.getAttribute('data-large-src');
      activeThumbIndex = index;
      if (mainImage && largeSrc) {
        mainImage.setAttribute('src', largeSrc);
        mainImage.removeAttribute('srcset');
      }
      syncZoomImage(index);
      thumbButtons.forEach((thumb) => {
        const selected = thumb === button;
        thumb.classList.toggle('is-selected', selected);
        thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (selected) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    };

    thumbButtons.forEach((button) => {
      on(button, 'click', () => {
        const index = Number(button.dataset.pdpV3ThumbIndex || 0);
        selectThumb(button, index);
      });
    });
    syncZoomImage(activeThumbIndex);

    const openZoom = (trigger) => {
      if (!zoomDialog) return;
      lastZoomTrigger = trigger || null;
      syncZoomImage(activeThumbIndex);
      zoomDialog.hidden = false;
      zoomOpen?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('has-lightbox');
      zoomClose?.focus();
    };

    const closeZoom = () => {
      if (!zoomDialog || zoomDialog.hidden) return;
      zoomDialog.hidden = true;
      zoomOpen?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('has-lightbox');
      lastZoomTrigger?.focus?.();
    };

    const moveZoom = (step) => {
      if (!galleryItems.length) return;
      activeThumbIndex = (activeThumbIndex + step + galleryItems.length) % galleryItems.length;
      selectThumb(galleryItems[activeThumbIndex].button, activeThumbIndex);
    };

    on(zoomOpen, 'click', () => openZoom(zoomOpen));
    section.querySelectorAll('[data-pdp-v3-zoom-close]').forEach((button) => on(button, 'click', closeZoom));
    section.querySelectorAll('[data-pdp-v3-zoom-prev]').forEach((button) => on(button, 'click', () => moveZoom(-1)));
    section.querySelectorAll('[data-pdp-v3-zoom-next]').forEach((button) => on(button, 'click', () => moveZoom(1)));
    on(document, 'keydown', (event) => {
      if (event.key === 'Escape') closeZoom();
      if (!zoomDialog || zoomDialog.hidden) return;
      if (event.key === 'ArrowLeft') moveZoom(-1);
      if (event.key === 'ArrowRight') moveZoom(1);
    });

    const trueView = section.querySelector('[data-pdp-v3-true-view]');
    const track = section.querySelector('[data-pdp-v3-true-track]');
    if (trueView && track && section.dataset.carouselAutoplay === 'true') {
      const interval = window.setInterval(() => {
        const step = track.querySelector('[data-pdp-v3-true-slide]');
        if (!step) return;
        const next = track.scrollLeft + step.clientWidth;
        const max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: next >= max ? 0 : next, behavior: 'smooth' });
      }, 5000);
      signal.addEventListener('abort', () => window.clearInterval(interval), { once: true });
    }

    const productForm = section.querySelector('product-form-component form');
    const variantIdInput = productForm?.querySelector('input[name="id"]');
    const variantInputs = Array.from(section.querySelectorAll('variant-picker input[type="radio"]'));
    const variantDataScript = section.querySelector('[data-pdp-v3-variants]');
    let variants = [];

    if (variantDataScript?.textContent) {
      try {
        variants = JSON.parse(variantDataScript.textContent);
      } catch (error) {
        variants = [];
      }
    }

    const selectedVariant = () => {
      const checkedInputs = variantInputs.filter((input) => input.checked);
      if (checkedInputs.length === 0) return null;

      const selectedOptions = Array.from(section.querySelectorAll('variant-picker fieldset'))
        .map((fieldset) => fieldset.querySelector('input[type="radio"]:checked')?.value)
        .filter((value) => value != null);

      if (variants.length && selectedOptions.length) {
        const variant = variants.find((item) => {
          if (!Array.isArray(item.options) || item.options.length !== selectedOptions.length) return false;
          return item.options.every((option, index) => option === selectedOptions[index]);
        });
        if (variant?.id) return variant;
      }

      const checkedWithVariant = checkedInputs.find((input) => input.dataset.variantId);
      return checkedWithVariant?.dataset.variantId ? { id: checkedWithVariant.dataset.variantId } : null;
    };

    const syncOptionLabels = () => {
      section.querySelectorAll('variant-picker fieldset').forEach((fieldset) => {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        const label = Array.from(section.querySelectorAll('[data-pdp-v3-option-label]'))
          .find((node) => node.dataset.optionName === checked.dataset.optionName);
        if (label) label.textContent = checked.value;
      });
    };

    const syncPrice = (variant) => {
      if (!variant) return;
      const price = section.querySelector('[data-pdp-v3-price-current]');
      const compare = section.querySelector('[data-pdp-v3-price-compare]');
      const saveBadge = section.querySelector('[data-pdp-v3-save-badge]');
      const availability = section.querySelector('[data-pdp-v3-availability]');
      if (price && variant.price) price.textContent = variant.price;
      const showCompare = Number(variant.compare_at_price_raw || 0) > Number(variant.price_raw || 0);
      if (compare) {
        compare.textContent = variant.compare_at_price || '';
        compare.classList.toggle('is-hidden', !showCompare);
      }
      if (saveBadge) {
        saveBadge.textContent = `Save ${variant.save_percent || 0}%`;
        saveBadge.classList.toggle('is-hidden', !showCompare);
      }
      if (availability && variant.availability) availability.textContent = variant.availability;
    };

    const syncProductFormVariant = () => {
      const variant = selectedVariant();
      const nextVariantId = variant?.id ? String(variant.id) : null;
      if (variantIdInput && nextVariantId && variantIdInput.value !== nextVariantId) {
        variantIdInput.value = nextVariantId;
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncPrice(variant);
      syncOptionLabels();
    };

    syncProductFormVariant();
    syncOptionLabels();
    syncPrice(selectedVariant());
    variantInputs.forEach((input) => {
      on(input, 'change', syncProductFormVariant);
    });
    on(productForm, 'submit', syncProductFormVariant);
    section.dataset.pdpV3ListenerCount = String(listenerCount);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-v3-m01-window"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function all(root, selector) {
      return Array.prototype.slice.call(root.querySelectorAll(selector));
    }

    function setText(node, value) {
      if (node) {
        node.textContent = value || "";
      }
    }

    function uniqueMediaItems(root) {
      var seen = {};
      return all(root, "[data-pdp-v3-m01-window-media]").reduce(function (items, node) {
        var gid = node.getAttribute("data-media-gid") || "";
        var src = node.getAttribute("data-full-src") || "";
        if (!src || seen[gid || src]) {
          return items;
        }
        seen[gid || src] = true;
        items.push({
          gid: gid,
          src: src,
          alt: node.getAttribute("data-full-alt") || ""
        });
        return items;
      }, []);
    }

    function bindWindow(root) {
      if (!root || root.getAttribute("data-pdp-v3-m01-window-bound") === "true") {
        return;
      }
      root.setAttribute("data-pdp-v3-m01-window-bound", "true");

      var mediaItems = uniqueMediaItems(root);
      var activeMedia = 0;
      var mainImage = root.querySelector("[data-pdp-v3-m01-window-main-image]");
      var status = root.querySelector("[data-pdp-v3-m01-window-status]");
      var lightbox = root.querySelector("[data-pdp-v3-m01-window-lightbox]");
      var zoomImage = root.querySelector("[data-pdp-v3-m01-window-zoom-image]");
      var zoomCaption = root.querySelector("[data-pdp-v3-m01-window-zoom-caption]");
      var zoomCounter = root.querySelector("[data-pdp-v3-m01-window-zoom-counter]");
      var zoomOpen = root.querySelector("[data-pdp-v3-m01-window-zoom-open]");
      var lastZoomTrigger = null;

      function syncThumbs(gid) {
        all(root, "[data-pdp-v3-m01-window-thumb]").forEach(function (thumb) {
          var selected = thumb.getAttribute("data-media-gid") === gid;
          thumb.classList.toggle("is-active", selected);
          if (selected) {
            thumb.setAttribute("aria-current", "true");
          } else {
            thumb.removeAttribute("aria-current");
          }
        });
      }

      function setActiveMedia(item, message) {
        if (!item || !mainImage) {
          return;
        }
        mainImage.setAttribute("src", item.src);
        mainImage.setAttribute("alt", item.alt);
        syncThumbs(item.gid);
        setText(status, message || "");
      }

      function syncZoom() {
        var item = mediaItems[activeMedia];
        if (!item || !zoomImage) {
          return;
        }
        zoomImage.setAttribute("src", item.src);
        zoomImage.setAttribute("alt", item.alt);
        setText(zoomCaption, item.alt);
        setText(zoomCounter, String(activeMedia + 1) + " / " + String(mediaItems.length));
      }

      all(root, "[data-pdp-v3-m01-window-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var gid = thumb.getAttribute("data-media-gid") || "";
          var next = mediaItems.findIndex(function (item) {
            return item.gid === gid;
          });
          if (next < 0) {
            return;
          }
          activeMedia = next;
          setActiveMedia(mediaItems[activeMedia], "Media selected.");
        });
      });

      function openZoom(trigger) {
        if (!lightbox || mediaItems.length === 0) {
          return;
        }
        lastZoomTrigger = trigger || null;
        syncZoom();
        lightbox.hidden = false;
        if (zoomOpen) {
          zoomOpen.setAttribute("aria-expanded", "true");
        }
        var closeButton = lightbox.querySelector("[data-pdp-v3-m01-window-zoom-close]");
        if (closeButton) {
          closeButton.focus();
        }
      }

      function closeZoom() {
        if (!lightbox || lightbox.hidden) {
          return;
        }
        lightbox.hidden = true;
        if (zoomOpen) {
          zoomOpen.setAttribute("aria-expanded", "false");
        }
        if (lastZoomTrigger) {
          lastZoomTrigger.focus();
        }
      }

      function moveZoom(step) {
        if (mediaItems.length === 0) {
          return;
        }
        activeMedia = (activeMedia + step + mediaItems.length) % mediaItems.length;
        syncZoom();
        setActiveMedia(mediaItems[activeMedia], "");
      }

      if (zoomOpen) {
        zoomOpen.addEventListener("click", function () {
          openZoom(zoomOpen);
        });
      }
      all(root, "[data-pdp-v3-m01-window-zoom-close]").forEach(function (button) {
        button.addEventListener("click", closeZoom);
      });
      all(root, "[data-pdp-v3-m01-window-zoom-prev]").forEach(function (button) {
        button.addEventListener("click", function () {
          moveZoom(-1);
        });
      });
      all(root, "[data-pdp-v3-m01-window-zoom-next]").forEach(function (button) {
        button.addEventListener("click", function () {
          moveZoom(1);
        });
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          closeZoom();
        }
      });

      var variantDataNode = root.querySelector("[data-pdp-v3-m01-window-variants]");
      var variants = [];
      try {
        variants = variantDataNode ? JSON.parse(variantDataNode.textContent || "[]") : [];
      } catch (error) {
        variants = [];
      }

      var colorPosition = Number(root.getAttribute("data-pdp-v3-m01-window-color-position") || "0");
      var colorLabel = root.querySelector("[data-pdp-v3-m01-window-color-label]");
      var priceNode = root.querySelector("[data-pdp-v3-m01-window-price]");
      var compareNode = root.querySelector("[data-pdp-v3-m01-window-compare]");
      var discountNode = root.querySelector("[data-pdp-v3-m01-window-discount]");
      var inventoryNode = root.querySelector("[data-pdp-v3-m01-window-inventory]");
      var variantInput = root.querySelector("[data-pdp-v3-m01-window-variant-input]");
      var atcButton = root.querySelector("[data-pdp-v3-m01-window-atc]");

      function sanitizeQuantity(value) {
        var next = String(value || "").trim();
        if (!/^[1-9]\d*$/.test(next)) {
          return 1;
        }
        return Number(next);
      }

      function syncQuantity(value) {
        var next = sanitizeQuantity(value);
        all(root, "[data-pdp-v3-m01-window-quantity-input]").forEach(function (input) {
          input.value = String(next);
        });
      }

      function matchingVariant(value) {
        if (!colorPosition) {
          return null;
        }
        var optionOffset = colorPosition - 1;
        return variants.find(function (variant) {
          return variant.available && variant.options && variant.options[optionOffset] === value;
        }) || variants.find(function (variant) {
          return variant.options && variant.options[optionOffset] === value;
        }) || null;
      }

      all(root, "[data-pdp-v3-m01-window-color-option]").forEach(function (button) {
        button.addEventListener("click", function () {
          var value = button.getAttribute("data-option-value") || "";
          var variant = matchingVariant(value);
          all(root, "[data-pdp-v3-m01-window-color-option]").forEach(function (optionButton) {
            var selected = optionButton === button;
            optionButton.classList.toggle("is-active", selected);
            optionButton.setAttribute("aria-pressed", selected ? "true" : "false");
          });
          setText(colorLabel, value);
          if (variant) {
            setText(priceNode, variant.price);
            if (compareNode) {
              if (variant.compare_at_price) {
                compareNode.hidden = false;
                setText(compareNode, variant.compare_at_price);
              } else {
                compareNode.hidden = true;
                setText(compareNode, "");
              }
            }
            if (inventoryNode) {
              setText(inventoryNode, variant.available ? inventoryNode.getAttribute("data-in-stock-label") || inventoryNode.textContent : inventoryNode.getAttribute("data-sold-out-label") || inventoryNode.textContent);
            }
            if (discountNode) {
              if (variant.discount_badge) {
                discountNode.hidden = false;
                setText(discountNode, variant.discount_badge);
              } else {
                discountNode.hidden = true;
                setText(discountNode, "");
              }
            }
            if (variantInput) {
              variantInput.value = String(variant.id);
            }
            if (atcButton) {
              atcButton.disabled = !variant.available;
              setText(atcButton, variant.available ? atcButton.getAttribute("data-atc-label") || atcButton.textContent : atcButton.getAttribute("data-sold-out-label") || atcButton.textContent);
            }
            var nextUrl = new URL(window.location.href);
            nextUrl.searchParams.set("variant", String(variant.id));
            window.history.replaceState({}, "", nextUrl.toString());
          }
        });
      });

      all(root, "[data-pdp-v3-m01-window-quantity-minus]").forEach(function (button) {
        button.addEventListener("click", function () {
          var input = root.querySelector("[data-pdp-v3-m01-window-quantity-input]");
          syncQuantity(Math.max(1, sanitizeQuantity(input ? input.value : "1") - 1));
        });
      });

      all(root, "[data-pdp-v3-m01-window-quantity-plus]").forEach(function (button) {
        button.addEventListener("click", function () {
          var input = root.querySelector("[data-pdp-v3-m01-window-quantity-input]");
          syncQuantity(sanitizeQuantity(input ? input.value : "1") + 1);
        });
      });

      all(root, "[data-pdp-v3-m01-window-quantity-input]").forEach(function (input) {
        input.addEventListener("change", function () {
          syncQuantity(input.value);
        });
        input.addEventListener("blur", function () {
          syncQuantity(input.value);
        });
      });

      all(root, "[data-pdp-v3-m01-window-review-summary]").forEach(function (button) {
        button.addEventListener("click", function () {
          var targetId = button.getAttribute("data-review-target") || "";
          var target = targetId ? document.getElementById(targetId) : null;
          if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      });

      all(root, "[data-pdp-v3-m01-window-tag]").forEach(function (button) {
        button.addEventListener("click", function () {
          all(root, "[data-pdp-v3-m01-window-tag]").forEach(function (tag) {
            tag.setAttribute("aria-pressed", tag === button ? "true" : "false");
          });
        });
      });
    }

    function bindAll() {
      all(document, "[data-pdp-v3-m01-window-root]").forEach(bindWindow);
    }

    document.addEventListener("DOMContentLoaded", bindAll);
    document.addEventListener("shopify:section:load", bindAll);
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-v3-m05-true-view"]) return;
  try {
    
  (function () {
    function initTrueView(root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-v3-m05-true-view-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-v3-m05-true-view-dot]'));
      var prev = root.querySelector('[data-pdp-v3-m05-true-view-prev]');
      var next = root.querySelector('[data-pdp-v3-m05-true-view-next]');

      if (!slides.length) {
        return;
      }

      var activeOrder = 0;

      function setActive(nextOrder) {
        var lastOrder = slides.length - 1;
        activeOrder = Math.max(0, Math.min(nextOrder, lastOrder));

        slides.forEach(function (slide, order) {
          var isActive = order === activeOrder;
          var isPeekLeft = order === activeOrder - 1;
          var isPeekRight = order === activeOrder + 1;

          slide.classList.toggle('is-active', isActive);
          slide.classList.toggle('is-peek-left', isPeekLeft);
          slide.classList.toggle('is-peek-right', isPeekRight);
          slide.classList.toggle('is-hidden', !isActive && !isPeekLeft && !isPeekRight);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach(function (dot, order) {
          var isActive = order === activeOrder;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        if (prev) {
          prev.disabled = activeOrder === 0;
        }
        if (next) {
          next.disabled = activeOrder === lastOrder;
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          setActive(activeOrder - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          setActive(activeOrder + 1);
        });
      }

      dots.forEach(function (dot, order) {
        dot.addEventListener('click', function () {
          setActive(order);
        });
      });

      setActive(0);
    }

    function initAll(scope) {
      var roots = Array.prototype.slice.call((scope || document).querySelectorAll('[data-pdp-v3-m05-true-view]'));
      roots.forEach(initTrueView);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
